export default __webpack_public_path__ + "static/g-lewis-5a5101957e997178956c0d74a1b72a43.jpg";